import { createContext, useContext } from 'react'
import { type AccountOpeningTypeSelector, type AccountType } from '../../../models/AccountOpening'
import { type AccountOpeningItemCopy } from '../../../models/AccountOpeningDescriptor'
import { type ContactOption, type WizardContext } from '../domain/types'

export interface WizardFlow {
  ctx: WizardContext
  accountTypes: AccountType[]
  selectors: AccountOpeningTypeSelector[]
  contactOptions: ContactOption[]
  defaultHolderName: string | null
  defaultHolderContactId: string | null
  readOnly: boolean
  itemsCopy: Required<AccountOpeningItemCopy>
}

export const WizardFlowContext = createContext<WizardFlow | null>(null)

export const useWizardFlow = (): WizardFlow => {
  const flow = useContext(WizardFlowContext)
  if (!flow) {
    throw new Error('useWizardFlow must be used inside a WizardFlowContext.Provider')
  }
  return flow
}
